import { SchedulerRunNotification } from './scheduler-run-notification';

export default {
  tag: 'schedulerrunnotification',
  format: '<SchedulerRunNotification />',
  sourcePipeline: (source: string) => source,
  componentFn: ({ node, ...props }: any) => {
    return <SchedulerRunNotification {...props} />;
  },
};
